import { MatTableDataSource, MatPaginator, MatSort, DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS } from '@angular/material';
import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { ErrorStateMatcher } from '@angular/material/core';
import Swal from "sweetalert2";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../models/messages';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';
import { Cuotas } from '../../../models/Cuotas';
import { map, startWith } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD"
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-detalle-pago',
  templateUrl: './detalle-pago.component.html',
  styleUrls: ['./detalle-pago.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]

})
export class DetallePagoComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  @Input() usuario: string;
  @Output() cerrarDetallePago = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  idProv;
  razonSocialFilter = new FormControl('');
  fechaFilter = new FormControl('');
  TipoMoneda: string;
  Deposito_a_Aplicar: number;
  razSocial: string;
  editar: boolean;
  loading: boolean = false;
  isLoading: boolean = false;
  save: boolean = false;
  user: any;
  formularioEditarUsuario: FormGroup;
  id_user: string;
  Titulo: string;
  Moneda: number;
  filteredProv: Observable<any[]>;
  proveedoresArr;
  importe: number = 5000;
  total: any = 0;
  datosDP: any;
  formDetallePago: FormGroup;
  idEmpresa: string;
  ListaCuota: any;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns: string[] = ['checked', 'Fecha', 'RazonSocialProveedor', 'Factura', 'NCuota', 'Importe', 'Importe_Ejecutado', 'Importe_Pendiente']
  dataSource = new MatTableDataSource();
  PagoTotales: any = {
    Total: 0,
    Saldo: 0
  };
  cuotas: Cuotas[] = [];

  pagoGeneral: any = {
    "Fecha": "",
    "Empresa": "",
    "Moneda": 0,
    "PagoTotal": "",
    "OperacionDetalle": []
  }
  Cuerpo: any = {
    "Pagos": []
  }

  dataFiltro: FormGroup;
  filterValues = {
    Proveedor: '',
    Fecha: '',
  };


  constructor(private datepipe: DatePipe, private cobranzasService: CobranzasService) {
    this.dataFiltro = new FormGroup({
      "Proveedor": new FormControl(''),
      "Fecha": new FormControl(''),

    });
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Titulo = "Detalle de pago";

    try {
      this.datosDP = this.cobranzasService.datosDetallePago;
      this.TipoMoneda = this.datosDP.Moneda_Dsc;
      this.Moneda = this.datosDP.Moneda;
      this.razSocial = this.datosDP.RazonSocialAdquirente;
      this.Deposito_a_Aplicar = this.datosDP.Deposito_a_Aplicar;
      this.ObtenerCuotas();
    } catch (error) {
      this.cerrarDetallePago.emit();
    }


    this.formDetallePago = new FormGroup({
      "idEmpresas": new FormControl('', Validators.required),
      "Moneda": new FormControl(0, Validators.required),
    });

  }

  ngOnInit() {

    this.razonSocialFilter.valueChanges.subscribe(
      Proveedor => {
        this.filterValues.Proveedor = Proveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.fechaFilter.valueChanges.subscribe(
      Fecha => {
        this.filterValues.Fecha = (Fecha === null ? "" : this.datepipe.transform(Fecha, 'yyyy-MM-dd'));
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
  }

  borrarFiltros() {
    this.cuotas = JSON.parse(sessionStorage.getItem('lstCuotas'));
    return this.cuotas;
  }

  filterItems2(query: string) {
    let filterItems2 = query1 => {

      return this.cuotas.filter((el) =>
        (new Date(el.Fecha_de_Pago).toISOString().split('T')[0] == new Date(query1).toISOString().split('T')[0]) === true
      );
    }
    this.cuotas = filterItems2(query);

  }

  createFilter(): (data: any, filter: string) => boolean {
    return function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.RazonSocialProveedor.toString().toLowerCase().indexOf(searchTerms.Proveedor) !== -1
        && data.Fecha_de_Pago == (searchTerms.Fecha == "" ? data.Fecha_de_Pago : searchTerms.Fecha)
    }
  }

  ObtenerCuotas() {
    this.isLoading = true;
    this.loading = true;

    this.cobranzasService.ObtenerCuotasPago(this.datosDP.Moneda, this.datosDP.idAdquirente).subscribe(
      res => {
        let data :any = res ;
        sessionStorage.setItem('lstCuotas', JSON.stringify(data))
        this.ObtenerAdquirenteCombo();
        data.forEach(item => {
          this.cuotas.push(item as Cuotas);
        });
        this.cuotas.forEach(object =>
          object.checked = false);
        this.dataSource = new MatTableDataSource(this.cuotas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
        this.isLoading = false;
      })
  }

  Calcular(valor) {
    this.PagoTotales.Total = 0;
    this.PagoTotales.Saldo = 0;
    let sumaTotal: number = 0;
    let saldoTotal: number = 0;

    for (let item of this.cuotas) {
      if (item.checked) {
        sumaTotal += Number(item.Importe_Pendiente);
        saldoTotal = this.Deposito_a_Aplicar - sumaTotal;
        this.PagoTotales.Total = sumaTotal;
        this.PagoTotales.Saldo = saldoTotal;
        
      }
    }
    console.log("Totales", this.PagoTotales); 
  }

  
  
  guardarPago(){
    let newArray: any = [];
    for (let item of this.cuotas) {
      if (item.checked) {
        newArray.push(item);
      }
    }

    this.Cuerpo = {
      "Pagos": []
    }
    newArray.forEach(item => {
      this.Cuerpo.Pagos.push(
        {
          'Alta_Canal': 'W',
          'Alta_Fecha': this.datepipe.transform(Date(), 'yyyy-MM-dd'),
          'Alta_Usuario': this.user.Usuario,
          'Estado': 'P',
          'Fecha': this.datepipe.transform(Date(), 'yyyy-MM-dd'),
          'Moneda': this.Moneda,
          'idCuotas': item.idCuotas,
          'Liquidar': 0,
          'idComprobante': item.idComprobante,
          'Tipo_Cobranza': item.Tipo_Cobranza,
          'idAdquirente': this.datosDP.idAdquirente,
          'idProveedor': item.idProveedor,
          'idCobranza': this.datosDP.idCobranza
        })
    });

    if (this.Cuerpo.Pagos.length > 1 && this.PagoTotales.Total > this.Deposito_a_Aplicar) {
      
      
    } else if (this.PagoTotales.Total == 0) {
      Swal.fire({
        title: "error",
        text: "Seleccione una casilla",
        type: "info",
        allowOutsideClick: false,
        heightAuto: false
      });
    } else if (this.Cuerpo.Pagos.length == 1 && this.PagoTotales.Total > this.Deposito_a_Aplicar) {
      Swal.fire({
        title: '¿Desea continuar?',
        text: 'Seleccione la acción a seguir',
        type: 'warning',
        showCancelButton: true,
        showConfirmButton: true,
        focusConfirm: true,
        confirmButtonColor: '#3bbd0b',
        cancelButtonColor: '#ff7800',
        confirmButtonText: 'Abonar',
        cancelButtonText: 'Conciliar',
        showCloseButton: true,
        reverseButtons: true,
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          this.abonar();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.conciliar();
          
        }
      })
    } else {
      this.pagar();
    }
  }

  pagar(){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de realizar el pago ?',
      type: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      focusConfirm: true,
      confirmButtonColor: '#3bbd0b',
      cancelButtonColor: '#db1616',
      confirmButtonText: 'Si, realizar pago',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Espere",
          text: "Guardando Información",
          type: "info",
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();
        this.cobranzasService.GuardarPago(this.Cuerpo).subscribe(res2 => {
          Swal.fire({
            title: "Success",
            text: "Pago Registrado Correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp2 => {
            if (resp2.value == true) {
              this.cerrarDetallePago.emit();
              this.refresh.emit();
            }
          });
        })
      } 
    })
  }

  abonar(){
    Swal.fire({
      title: "Espere",
      text: "Guardando Información",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.cobranzasService.GuardarPago(this.Cuerpo).subscribe(res => {
      Swal.fire({
        title: "Success",
        text: "Pago Registrado Correctamente",
        type: "success",
        allowOutsideClick: false,
        heightAuto: false
      }).then(resp => {
        if (resp.value == true) {
          this.cerrarDetallePago.emit();
          this.refresh.emit();
        }
      });
    })
  }

  conciliar(){
    Swal.fire({
      title: "Espere",
      text: "Guardando Información",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    this.Cuerpo.Pagos.forEach(element => {
      element.Liquidar = 1
    });        
    Swal.showLoading();
    this.cobranzasService.GuardarPago(this.Cuerpo).subscribe(res1 => {
      Swal.fire({
        title: "Success",
        text: "Pago Conciliado Correctamente",
        type: "success",
        allowOutsideClick: false,
        heightAuto: false
      }).then(resp1 => {
        if (resp1.value == true) {
          this.cerrarDetallePago.emit();
          this.refresh.emit();
        }
      });
    })
  }


  CerrarPopUp() {
    this.cerrarDetallePago.emit();
  }

  private _filterProd(value: string): any[] {
    const filterValue = value.toString().toLowerCase;
    return this.proveedoresArr.filter(state => state.RazonSocialProveedor.toLowerCase().includes(filterValue) === true)
  }

  ObtenerAdquirenteCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstCuotas'));
    this.proveedoresArr = this.proveedoresArr.filter((v, i, a) =>
      a.findIndex(t => (t.RazonSocialProveedor === v.RazonSocialProveedor)) === i
    );
    this.filteredProv = this.razonSocialFilter.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProd(state) : this.proveedoresArr.slice()
        )
      );
  }

  obtenerIdAdq(termino: string) {
    this.razonSocialFilter.setValue(termino.toLowerCase());
    this.idProv = termino;

  }

  EnteroObtenerRucRazSocialAdq(termino: string = '') {
    this.razonSocialFilter.setValue(termino);
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.RazonSocialProveedor.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProv = p.RazonSocialProveedor;

        }
      }
    }
  }
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid);
  }
}